import matchHeight from "jquery-match-height";

"use strict";
$(function() {
	$('.eq-box-item').matchHeight({
        byRow: false,
        property: 'min-height',
        target: null,
        remove: false
    });
	$('.eq-post-item-title').matchHeight({
        byRow: true,
        property: 'min-height',
        target: null,
        remove: false
    });
    window.addEventListener("resize", $.fn.matchHeight._update());
});